<template>
  <!-- 试题按钮 -->
  <!-- 老师视角、学生视角 隐藏掉练习 -->
  <div :class="productFlag == 1 ? 'platform_jump_btn' : 'platform_jump_btn1'"
    v-if="!isChild && !this.$route.query.userType">
    <template v-if="buttonShowArr.length">
      <!-- 实训按钮 -->
      <!--    <template v-if="type == '3'" v-for="(val, key) in platFromBtn">-->
      <template v-if="type == '3' || type == '7'"  >
        <template v-for="(item, index) in buttonShowArr"  v-if="buttonShowArr.length==1">
        <el-button :class="type == '7'?'trainBtn':'otherBtn'" :key="item.index + '_' + index" v-bury="{ start: true }" @click="startFn(item.platform, 0, item.index)"
          type="primary">业务处理
          <!-- {{ platFromBtn[item.platform] || item.platform }} -->
        </el-button>
      </template>
      <template v-if="buttonShowArr.length>1">
        <el-button :class="type == '7'?'trainBtn':'otherBtn'"  v-bury="{ start: true }" @click="startFn(buttonShowArr[0].platform, 0, 0)"
          type="primary">业务处理
        </el-button>
      </template>
      </template>
      <!-- 单项按钮 -->
      <template v-if="type == '1' || type == '2'">
        <!-- <el-button
					v-if="buttonShowArr[0].platform !== 'RPAOS' && contains(buttonShowArr,'RPAOS') && (contains(buttonShowArr,'ctx') || contains(buttonShowArr,'ptx') || contains(buttonShowArr,'jss') || contains(buttonShowArr,'gxl'))"
				  v-bury="{ start: true }"
				  @click="resetData()"
					:disabled="resetDataBtn || isFirst"
					class="reset_btn1"
				>重置数据</el-button
				> -->
        <div @click="startIforame($event)" v-if="buttonShowArr[0].platform === 'RPAOS'" class="task_btn"
          ref="startSoftware" :href="startSoftwareUrl">
          启动RPA
        </div>
        <el-button v-bury="{ start: true }" v-else @click="startFn(buttonShowArr[0].platform)"
          type="primary">开始练习</el-button>

        <!-- <template v-if="professional == 9 && prodId == 7 && isReset">
          <el-button
            v-bury="{ start: true }"
            @click="resetBtn()"
            type="primary"
            class="reset_btn"
          >重置</el-button
          >
          <span style="font-size: 12px; color: #5397f7; margin-left: 10px"
          >重置试题后请重启RPA后再进行练习！</span
          >
        </template> -->
      </template>
    </template>

  </div>
  <!-- (子) 浮窗按钮 -->
  <div class="child_platform_jump_btn" v-else-if="childrenBtn.length">
    <!-- 子模板的按钮展示   -->
    <template v-for="childSort in childrenBtn">
      <div @click="startIforame($event, childSort)" class="rpa_btn" v-if="buttonShowArr[childSort].platform === 'RPAOS'"
        :key="childSort + 'child'" ref="startSoftware" :href="startSoftwareUrl">
        启动RPA
      </div>
      <el-button v-else :key="childSort + 'child'" v-bury="{ start: true }" @click="
        startFn(
          buttonShowArr[childSort].platform,
          buttonShowArr[childSort].platform === 'BigDataOS' || buttonShowArr[childSort].platform === 'ctx' ? 2 : 1,
          childSort
        )
        " class="btnStyle">
        {{ platFromBtn[buttonShowArr[childSort].platform] || buttonShowArr[childSort].platform }}
      </el-button>
    </template>
  </div>
</template>

<script>
import * as api from "@/api/courseApi";
import jumpUtils from "@/utils//platformJump.js";
import { getQuery2object } from "@/utils/utils";

export default {
  props: {
    isChild: {
      type: Boolean,
      default: false,
    },
    buttonShowArr: {
      type: Array, // 试题内templates对应的platform
    },
    myStation: {
      type: Array, // 我的岗位
    },
    type: {
      type: [Number, String], //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
    },
    listItem: {
      type: Object, //资源/试题 -- 参数集合
      default: () => { },
    },
    courseId: {
      type: [Number, String], //课程id
    },
    classId: {
      type: [Number, String], //班级id
    },
    catalogId: {
      type: [Number, String], //目录id
    },
    childrenBtn: {
      type: Array, //子事项 -- 参数集合
      default: () => [],
    },
  },
  data() {
    return {
      productFlag: sessionStorage.getItem("productFlag"), //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
      professional: sessionStorage.getItem("professional"), //专业
      prodId: sessionStorage.getItem("prodId"), //产品id
      startSoftwareUrl: "", //rpa地址
      openShow: false, //是否启动团建
      beforePlatform: {}, //获取各平台跳转域名
      isReset: false, //是否显示重置按钮
      RPABTN: false,
      resetDataBtn: false,
      platFromBtn: {
        // professional == 1  智能审计
        auditExcel: '智能审计', // 开始练习
        // professional == 2   智能财税
        ctx: '财天下',
        ptx: '票天下',
        jss: '金税师',
        gxl: '供应链',
        shanglv: '商旅',
        dummy: '政务仿真',
        JiXiaoOS: '绩效管理',
        'basicdata': '运营中心',
        'budget': '数字管理会计',
        'dataAsset': '数据资产',
        'imagecenter': '影像中心',
        'reimburse': '报账中心',
        'settlement': '结算中心',
        'journal': '会计核算',
        'bill': '票据管理',
        'asset': '资产管理',
        'salary': '薪资管理',
        archives: '档案中心',
        cashier: '出纳中心',
        cost: '成本中心',
        'travel': '差旅费控',
        'purchase': '采购管理',
        'sale': '销售管理',
        'inventory': '库存管理',
        'tax': '金税师',
        'ToJss': '金税师',
        'ToTax': '金税师',
        // professional == 3  智能估值
        mgy: '摩估云',
        middleMGY: '摩估云中级',
        gzyy: '估值应用',
        // professional == 8   社交电商
        ECommerce: '电商实训',
        dummyPro: '电商调研',
        // professional == 24  三资
        zhcx: '综合查询',
        zcgl: '资产管理',
        zygl: '资源管理',
        zjbz: '资金报账',
        kjhs: '会计核算',
        dagl: '档案管理',
        // 补充
        BigDataOS: "大数据",
        ExcelOS: "答题板",
        ExcelOS_Bak: "答题板",  // 2022.12.8  王东东
        ExcelCustomOS: "答题板",
        FZBAOSHUI: "仿真报税",
        ChinaGovTaxApply: "电子税务局",
        "ChinaGovTaxApply2.0": "电子税务局",
        "ZLBigData2.0": "中联大数据",
        managementAccount: "管理会计",
        RPAOS: "RPA",
        rpaNum: 1,
      },
      isFirst: true,
      financeVersion: '',
    };
  },
  created() {
    // 获取各平台跳转域名
    this.getPlatformPath();
    this.getResetData(0, 0, 'noClick');
    // console.log('--buttonShowArr[childSort]--', this.buttonShowArr, this.childrenBtn)
  },
  mounted() { },
  watch: {
    listItem: function (val) {
      console.log(val)
      if (val.isFinish) {
        this.isReset = true;
      } else {
        this.isReset = false;
      }
    },
  },
  methods: {
    //根据资源ID 获取动态参数列表
    getparams(id, index) {
      let list = [];
      let param = {
        myId: this.listItem.id, // 资源/试题 -- id
        id: id, // templates -- id
        index: index ? index : 0, // templates -- index
      };
      return new Promise((resolve) => {
        api
          .getDynmaicParam(param)
          .then((rs) => {
            if (rs.code === "0") {

              if (rs.data.length > 0) {
                rs.data.map((item) => {
                  let obj = {
                    key: item.param,
                    value: item.value,
                  };
                  list.push(obj);
                });
              }
              resolve(list);
            } else {
              this.$messageWarning(rs.msg);
            }
          })
          .catch(error => {
            this.$messageError("获取试题参数出错！", error);
          });
      });
    },
    async isTeam() {
      //是否有小组
      let that = this;
      return api
        .jumpstx(that.courseId, that.$route.query.classId)
        .then((res) => res);
    },
    async isMyStation(id) {
      //是否有岗位权限
      let arr = [];
      this.myStation.forEach((v) => {
        arr.push(v.code);
      });
      return api
        .queryMyStationQes({
          questionId: id,
          roles: arr,
        })
        .then((res) => res);
    },
    //开始跳转
    async startFn(platform, openType = 0, eventSort = 0) {

      console.log(this.buttonShowArr)

      // console.log(platform)
      let that = this;
      if (platform !== 'RPAOS' && that.contains(that.buttonShowArr, 'RPAOS')) { //存在RPA事项的试题并且RPA事项不是第一事项
        // if(that.isFirst){
        // 	that.resetData()
        // }else{
        // 	that.getResetData(0,0,'click')
        // }
      }
      // if(platform !== 'RPAOS' && that.contains(that.buttonShowArr,'RPAOS') && !this.RPABTN) return;
      let eventList = that.listItem.templates;  // 试题中的事项集合

      if (!eventList[eventSort]) return that.$messageWarning("试题已更新，需要在课程中重新绑定试题");

      let parentObj = {
        templateCode: "",
        roles: "",
      };

      if (eventList == null) {
        that.$messageWarning("该章节暂无实操任务");
        return false;
      }
      console.log('--newObj--', eventList, eventSort)

      let paramsList = await that.getparams(eventList[eventSort].id, eventSort);
      console.log(paramsList,'')
      if (paramsList.length > 0) {
        paramsList.forEach((v) => {
          if (v.key === "templateCode") {
            parentObj.templateCode = v.value;
          }
          if (v.key === "roles") {
            parentObj.roles = v.value;
          }
        });

        // training.vue中 templateCode值 2022/09/28
        that.$emit('getTemplateCode', parentObj.templateCode)

        // if (that.$parent && that.$parent.startJump) that.$parent.startJump(parentObj);
        let queryuserId = "";
        if (that.professional == 9 && that.prodId == 7 && !that.contains(that.buttonShowArr, 'RPAOS')) {
          queryuserId = await that.queryResetExercise();
        }
        let jumpObj = {
          token: localStorage.getItem("Authorization"), // token
          productFlag: sessionStorage.getItem("productFlag"), // 产品标识：1、书证融通，2、单项训练，3、综合实训，4、真实任务
          courseId: that.courseId, // 课程id
          courseName: that.$route.query.courseName, // 课程名称
          catalogType: that.$route.query.catalogType, // 课程类型
          classId: that.$route.query.classId, // 班级id
          className: that.$route.query.className, // 班级名称
          platform: platform, // 平台标识
          paramsList: paramsList, // param
          listItem: that.listItem, // 试题参数集合
          myStation: that.myStation, // 我的岗位
          deptId: sessionStorage.getItem("deptId"), // 机构id
          deptName: sessionStorage.getItem("deptName"), // 机构名称
          userId: queryuserId
            ? queryuserId
            : sessionStorage.getItem("userId"), // 用户id
          username: sessionStorage.getItem("userName"), // 账号
          nickname: sessionStorage.getItem("loginName"), // 用户姓名
          userType: sessionStorage.getItem("userType"), // 用户类型
          mobile: sessionStorage.getItem("mobile"), // 手机号
          timestamp: new Date().getTime(),
          teamId: "",

          teamName: "",
          stationList: [],
          //====================================
          sex: sessionStorage.getItem("sex"), // 性别
          headImgUrl: "", // 头像
          idCard: "", // 身份证
          password: "e10adc3949ba59abbe56e057f20f883e",
          // item: ${questionDto.questionCode},
          item: "27011201-6fe9-46b4-ba7f-fe241aed2132", // questionCode
          clientId: "1349883712819109890",
          num: that.rpaNum // RPA重置次数
        };
        console.log(jumpObj)
        if (that.professional == 24) {//三资
          that.plateformJump(jumpObj, openType, eventSort, platform);
        }
        // else if (that.beforePlatform && that.beforePlatform.urlPath && that.beforePlatform.urlPath.includes('api-oauth/v1/oauth/ycyt2/oauth/token')){
        //   that.plateformJump(jumpObj, openType, eventSort, 'ycyth'); // 业财一体化跳转
        // }
        else if (jumpObj.productFlag == 3 || jumpObj.productFlag == 7) {
          //实训
          let isNext = false;
          let isMyStation = false;
          that
            .isTeam()
            .then((res) => {
              if (res.code == 0) {
                isNext = true;
                jumpObj.teamId = res.data.teamId;
                jumpObj.teamName = res.data.teamName;
                jumpObj.stationList = res.data.stationList;
              } else {
                isNext = false;
                that.$messageError(res.msg);
              }
            })
            .then(() => {
              if (!isNext) return;
              that
                .isMyStation(jumpObj.listItem.id)
                .then((rs) => {
                  if (rs.code == 0) {
                    if (rs.data || sessionStorage.getItem("userType") === '0' || sessionStorage.getItem("userType") === '1') {
                      isMyStation = true;
                    } else {
                      that.$messageWarning(
                        "对不起！您没有此任务执行的权限。"
                      );
                      isMyStation = false;
                    }
                  } else {
                    isMyStation = false;
                    that.$messageError(rs.msg);
                  }
                })
                .then(() => {
                  if (!isMyStation) return;
                  let  roleCode =''
                  // 多个按钮显示进入 传多岗位code
                  // if(that.buttonShowArr.length  && that.buttonShowArr.length >1 ){
                    if(that.myStation){
                    roleCode =that.myStation.map(((item)=>{
                          return item.code
                        })).toString()

                  }


                  that.plateformJump(jumpObj, openType, eventSort,'',roleCode); //平台跳转
                });
            });
        } else {
          // console.log(this.contains(this.buttonShowArr, "RPAOS"))
          // if (this.contains(this.buttonShowArr, "RPAOS")) {
          //   // if (!this.RPABTN) return;
          //   that.plateformJump(jumpObj, openType, eventSort, 'RPAOS'); //平台跳转
          // } else {
            that.plateformJump(jumpObj, openType, eventSort);
          // }

        }
      } else {
        if (platform === "dummy") {
          let jumpObj = {
            token: localStorage.getItem("Authorization"), // token
            productFlag: sessionStorage.getItem("productFlag"), // 产品标识：1、书证融通，2、单项训练，3、综合实训，4、真实任务
            courseId: that.courseId, // 课程id
            courseName: that.$route.query.courseName, // 课程名称
            courseType: that.$route.query.courseType, // 课程类型
            classId: that.$route.query.classId, // 班级id
            className: that.$route.query.className, // 班级名称
            platform: 'dummy', // 平台标识
            paramsList: [], // param
            listItem: that.listItem, // 试题参数集合
            myStation: that.myStation, // 我的岗位
            deptId: sessionStorage.getItem("deptId"), // 机构id
            deptName: sessionStorage.getItem("deptName"), // 机构名称
            userId: sessionStorage.getItem("userId"), // 用户id
            username: sessionStorage.getItem("userName"), // 账号
            nickname: sessionStorage.getItem("loginName"), // 用户姓名
            userType: sessionStorage.getItem("userType"), // 用户类型
            mobile: sessionStorage.getItem("mobile"), // 手机号
            timestamp: new Date().getTime(),
            teamId: "",
            teamName: "",
            stationList: [],
            //====================================
            sex: sessionStorage.getItem("sex"), // 性别
            headImgUrl: "", // 头像
            idCard: "", // 身份证
            password: "e10adc3949ba59abbe56e057f20f883e",
            // item: ${questionDto.questionCode},
            item: "27011201-6fe9-46b4-ba7f-fe241aed2132", // questionCode
            clientId: "1349883712819109890",
          };

          that.plateformJump(jumpObj, openType, eventSort); //平台跳转
        } else {
          that.$messageError("该任务发生了修改。请通知该【课程创建人】重新发布课程后，刷新当前任务。");
        }
      }
    },
    // RPA重置数据
    async resetData(eventSort = 0) {
      let that = this;
      let eventList = that.listItem.templates;  // 试题中的事项集合
      let obj = {
        "classId": that.$route.query.classId,
        "className": that.$route.query.className,
        "templateCode": "",
        "model": "zx",
        "questionId": that.listItem.id
      }
      if (!eventList[eventSort]) return that.$messageWarning("试题已更新，需要在课程中重新绑定试题");

      let paramsList = await that.getparams(eventList[eventSort].id, eventSort);
      if (paramsList.length > 0) {
        paramsList.forEach((v) => {
          if (v.key === "templateCode") {
            obj.templateCode = v.value;
          }
        });
        api.resetData(obj).then(res => {
          console.log(res)
          if (res.code == 0) {
            that.getResetData(0, 0, 'click')
          } else {
            that.$messageError(res.msg);
          }
        })
      }
    },
    async getResetData(openType = 0, eventSort = 0, type) {
      // console.log(type)
      let that = this;
      let eventList = that.listItem.templates;  // 试题中的事项集合
      if (!eventList[eventSort]) return that.$messageWarning("试题已更新，需要在课程中重新绑定试题");

      let paramsList = await that.getparams(eventList[eventSort].id, eventSort);
      let param = {
        "classId": that.$route.query.classId,
        "templateCode": "",
        "questionId": that.listItem.id
      }
      if (paramsList.length > 0) {
        paramsList.forEach((v) => {
          if (v.key === "templateCode") {
            param.templateCode = v.value;
          }
          if (v.key === "financeVersion") {
            this.financeVersion = v.value
          }
        });
        api.getResetData(param).then(res => {
          if (res.code == 0) {
            if (res.data) {
              that.isFirst = false
              if (res.data.status == 0 || res.data.status == 3 || res.data.status == 4) {
                this.resetDataBtn = true
              } else {
                this.resetDataBtn = false
              }

              if (res.data.status == 2) {
                this.RPABTN = true
              } else {
                this.RPABTN = false
                // if(type == 'click'){
                // 	this.$message({
                // 		message: '数据准备中，请稍候进入练习',
                // 		duration: 5000,
                // 		type: 'warning'
                // 	});
                // }
              }
              this.rpaNum = res.data.num

            } else {
              that.isFirst = true
            }

          } else {
            this.$messageError(res.msg);
          }
        })
      }

    },
    plateformJump(jumpObj, openType, eventSort, mechanisms,roleRode) {
      console.log(newObj,'newObj')
        console.log(eventSort,'eventSort')
        console.log(mechanisms,'mechanisms')
        console.log(openType,'openType')
        console.log(roleRode,'roleRode')

      //平台跳转
      //  mechanisms 跳转机制  目前是两种 业财一体化和常用跳转
      // open 新开页呈现。用于子事项的跳转
      let that = this;

      let newObj = {
        beforePlatform: this.beforePlatform,
        ...jumpObj,
      };


      jumpUtils.plateformJump(newObj, eventSort, mechanisms,roleRode).then((data) => {

        if (data.iframeUrl) {
          if (openType === 0) {
            if (data.platform === 'jss' && that.financeVersion) { // 金税师 拼接动态参数
              data.iframeUrl = data.iframeUrl + `&financeVersion=${that.financeVersion}`
            }
            that.$emit("platformJump", data, 0);

          } else if (openType === 1) {
            // 子iframe 跳转
            that.$emit("platformJump", data, 1);
          } else if (openType === 2) {
            // 新开页 跳转
            window.open(data.iframeUrl);
          }

        }
      });
      ///
    },
    //============================启动RPA===========================
    async startIforame(event, rpaIndex) {
      let that = this;
      let isNext = false;
      let teamId = "";
      let teamName = "";

      let rpaData = null;
      let eventList = that.listItem.templates;
      eventList.forEach((v, i) => {
        if (v.eventParam.split("&")[0].split("=")[0] == "platform") {
          let childplatform = v.eventParam.split("&")[0].split("=")[1];
          if (childplatform.indexOf("RPAOS") != -1) {
            rpaData = v;
          }
        }
      });
      let paramsList = await that.getparams(rpaData.id, rpaIndex);
      let queryuserId = "";
      if (that.professional == 9 && that.prodId == 7) {
        queryuserId = await that.queryResetExercise();
      }
      that.isTeam().then((res) => {
        if (res.code == 0) {
          isNext = true;
          teamId = res.data.teamId;
          teamName = res.data.teamName;
        } else {
          if (that.productFlag == 1 || that.productFlag == 2) {
            isNext = true;
          } else {
            isNext = false;
            that.$messageError(res.msg);
          }
        }

        if (!isNext) return;
        let jumpObj = {
          token: localStorage.getItem("Authorization"), // token
          productFlag: sessionStorage.getItem("productFlag"), // 产品标识：1、书证融通，2、单项训练，3、综合实训，4、真实任务
          courseId: that.courseId, // 课程id
          courseName: that.$route.query.courseName, // 课程名称
          classId: that.$route.query.classId, // 班级id
          className: that.$route.query.className, // 班级名称
          platform: that.buttonShowArr[0].platform, // 平台标识  2023.3.10.  涂磊说综合实训里RPA的platform 给 试题的跳转平台的platform that.buttonShowArr[0].platform
          paramsList: paramsList, // param
          listItem: that.listItem, // 试题参数集合
          userId: queryuserId ? queryuserId : sessionStorage.getItem("userId"), // 用户id
          username: sessionStorage.getItem("userName"), // 账号
          nickname: sessionStorage.getItem("loginName"), // 用户姓名
          userType: sessionStorage.getItem("userType"), // 用户类型
          mobile: sessionStorage.getItem("mobile"), // 手机号
          timestamp: new Date().getTime(),
          teamId: teamId, // 小组id
          teamName: teamName, // 小组名称
          resourceId: that.listItem.id, // 资源id
        };
        jumpUtils.rpaJump(jumpObj).then((data) => {

          that.startSoftwareUrl = data.iframeUrl;
          that.$nextTick(() => {
            if (this.$refs.startSoftware[0]) {
              window.protocolCheck(
                eval("this.$refs.startSoftware")[0].getAttribute("href"),
                function () {
                  var answer = confirm("检测到未安装编辑器，是否下载？");
                  if (answer) {
                    window.location = data.downloadUrl;
                    that.openShow = false;
                  } else {
                    that.openShow = false;
                    alert("已取消下载编辑器，无法启动。");
                  }
                }
              );
            } else {
              window.protocolCheck(
                eval("this.$refs.startSoftware").getAttribute("href"),
                function () {
                  var answer = confirm("检测到未安装编辑器，是否下载？");
                  if (answer) {
                    window.location = data.downloadUrl;
                    that.openShow = false;
                  } else {
                    that.openShow = false;
                    alert("已取消下载编辑器，无法启动。");
                  }
                }
              );
            }

            that.openShow = true;
            event.preventDefault
              ? event.preventDefault()
              : (event.returnValue = false);
          });
        });
      });
    },
    //======== 获取各平台跳转域名  =========
    getPlatformPath() {
      api.getPlatformPath(this.courseId).then((rs) => {
        if (rs.code == 0) {
          this.beforePlatform = {};
          if (rs.data.length > 0) {
            rs.data.forEach((v) => {
              v.platformPathList.forEach((val) => {
                if (val.isBind == 1) {
                  this.beforePlatform = {
                    urlPath: val.urlPath,
                    platform: v.platformTag,
                    code: val.code,
                    tag: val.tag
                  }
                  return
                }
              });
            });
          }
        } else {
          this.$messageError(rs.msg);
        }
      });
    },
    //跳转前查询userId
    queryResetExercise() {
      let param = {
        classId: this.classId,
        courseId: this.courseId,
        catalogId: this.catalogId,
        resourceId: this.listItem.id,
      };
      return new Promise((resolve) => {
        api.queryResetExercise(param).then((rs) => {
          if (rs.code === "0") {
            resolve(rs.data);
          } else {
            this.$messageError(rs.msg);
          }
        });
      });
    },
    resetBtn() {
      this.$tipsDialog(
        "提示",
        "请确认是否重置您的作答结果？",
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      ).then(() => {
        api
          .resetExercise({
            classId: this.classId,
            courseId: this.courseId,
            catalogId: this.catalogId,
            resourceId: this.listItem.id,
          })
          .then((rs) => {
            if (rs.code == 0) {
              this.$emit("init");
              // this.$parent.init()
            } else {
              this.$messageError(rs.msg);
            }
          });
      });
    },
    // 判断三天下
    contains(arr, val) {
      var i = arr.length;
      while (i--) {
        if (arr[i].platform === val) {
          return true;
        }
      }
      return false;
    }
  },
};
</script>
<style lang="scss">
.platform_jump_btn1 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .task_btn {
    width: 80px;
    height: 30px;
    border: 1px solid #5397f7;
    color: #5397f7;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
    line-height: 28px;
    padding: 0;
    cursor: pointer;
  }
  .trainBtn {
    padding: 10px 16px;
    font-size: 12px;
    border: 0;
    color: #fff;
    background: #215DE8;
  }
  .otherBtn {
    position: relative;
    padding: 8px 10px 8px 30px;
    background: #fff;
    border: 1px solid #5397f7;
    color: #5397f7;
    &::after {
      content: "";
      width: 16px;
      height: 16px;
      background: url("../views/studyCenter/img/start.png");
      background-size: 16px 16px;
      position: absolute;
      left: 10px;
      top: 7px;
    }
    &:hover {
      color: #fff;
      background: #5397f7;

      &::after {
        background: url("../views/studyCenter/img/start-hv.png");
        background-size: 16px 16px;
      }
    }
  }
}

.platform_jump_btn {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .reset_btn1 {
    margin-right: 10px;
    width: 95px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    background: #fff;
    border: 1px solid #5397f7;
    color: #5397f7;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background: linear-gradient(135deg,
          #1890ff 0%,
          #00b3f7 100%,
          #00b3f7 100%);
      color: #fff;
      border: none;
      opacity: 0.8;
    }
  }

  .reset_btn1.is-disabled {
    color: #C0C4CC;
    cursor: not-allowed;
    background-image: none;
    background-color: #FFF;
    border-color: #EBEEF5;

    &:hover {
      background: #FFF;
      opacity: 1;
    }
  }

  button,
  .task_btn {
    width: 95px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    background: linear-gradient(135deg, #1890ff 0%, #00b3f7 100%, #00b3f7 100%);
    border-radius: 16px;
    border: none;
    font-size: 12px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      background: linear-gradient(135deg,
          #1890ff 0%,
          #00b3f7 100%,
          #00b3f7 100%);
      border-radius: 16px;
      border: none;
      opacity: 0.8;
    }
  }

  .btnDisbaled {
    color: #C0C4CC;
    cursor: not-allowed;
    background-image: none;
    background-color: #FFF;
    border-color: #EBEEF5;

    &:hover {
      background: #FFF;
      opacity: 1;
    }
  }

  .reset_btn {
    background: #fff;
    border: 1px solid #5397f7;
    color: #5397f7;

    &:hover {
      background: linear-gradient(135deg,
          #1890ff 0%,
          #00b3f7 100%,
          #00b3f7 100%);
      color: #ffffff;
    }
  }
}

.child_platform_jump_btn {
  // min-width: 182px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;

  .btnStyle {
    padding: 0 10px;
    height: 30px;
    border: 1px solid #5397f7;
    color: #5397f7;
    margin-left: 10px;
    font-size: 12px;
    font-weight: 600;

    &:hover {
      background: linear-gradient(327deg, #69d5ff 0%, #0084ff 100%);
      color: #ffffff;
    }
  }

  .rpa_btn {
    width: 78px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border: 1px solid #5397f7;
    color: #5397f7;
    margin-left: 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      background: linear-gradient(327deg, #69d5ff 0%, #0084ff 100%);
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/platformBtn/trainingNewBtn.vue